import { render, staticRenderFns } from "./AlertFeedList.vue?vue&type=template&id=a1b91bbc&"
import script from "./AlertFeedList.vue?vue&type=script&lang=ts&"
export * from "./AlertFeedList.vue?vue&type=script&lang=ts&"
import style0 from "./AlertFeedList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports